// @ts-nocheck
/* eslint-disable react/jsx-props-no-spreading */
import { Button, ThemeProvider } from '@mui/material';
import React from 'react';
import buttonTheme from './buttonTheme';

export default function MuiButton({ children, ...rest }) {
  return (
    <ThemeProvider theme={buttonTheme}>
      <Button {...rest}>{children}</Button>
    </ThemeProvider>
  );
}
